import { call, fork, put, takeEvery } from 'redux-saga/effects';
import TagApi from '../../../lib/api/tag/TagApi';
import tagToastMsg from '../../../constants/service/toastMsg/tagToastMsg';
import toastMsg from '../../../lib/toastMsg';
import { appActions } from '../app';
import { tagActions } from './index';
import { TAG_GROUP_LIST_URL_PATH, TAG_LIST_URL_PATH } from '../../../constants/service/common/urlConstants';
import {
  TAG_RELATED_ITEM_TYPE,
  TAG_TAB_MAIN_SECTION_TYPE,
  TAG_TREND_KEYWORD_SECTION_TYPE,
  TAG_ALL_LIST_EXCEL_FILE_NAME,
  TAG_SELECTED_LIST_EXCEL_FILE_NAME,
  TAG_LIST_EXCEL_FILE_NAME,
} from '../../../constants/service/app/tagConstants';
import {
  _setResponseListForm,
  reDirectPage,
  setRequestForm,
  excelDownLoad,
  setMultipartForm,
  asyncSimpleModal,
} from '../../../lib/common';

function* fetchList() {
  /**
   *  태그 등록하기 전 필요한 데이터 가져오기
   */
  yield takeEvery(tagActions.PREPARE_INSERT_TAG_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.prepareInsertTag, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.PREPARE_INSERT_TAG_REQUEST_SUCCESS);

        yield put({ type: tagActions.PREPARE_INSERT_TAG_SUCCESS, payload: result.data });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.PREPARE_INSERT_TAG_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그명 중복검사 요청하기
   */
  yield takeEvery(tagActions.CHECK_TAG_NAME_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.checkTagName, setRequestForm(payload, false));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        yield put({ type: tagActions.CHECK_TAG_NAME_SUCCESS, payload: result.data });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.CHECK_TAG_NAME_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 등록 요청하기
   */
  yield takeEvery(tagActions.INSERT_TAG_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.insertTag, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.INSERT_TAG_REQUEST_SUCCESS);

        reDirectPage({ path: TAG_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.INSERT_TAG_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 검색 리스트 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_SEARCH_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagSearchList, setRequestForm(payload, false));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        yield put({ type: tagActions.GET_TAG_SEARCH_LIST_SUCCESS, payload: result.data });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_SEARCH_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  추천 태그 리스트 요청하기
   */
  yield takeEvery(tagActions.GET_RECOMMEND_TAG_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagSearchList, setRequestForm(payload, false));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        /**
         *  검색 요청한 키워드는 추천 태그 리스트에서 제외하기
         */
        const data = {
          tagSearchSelectList: result.data.tagSearchSelectList.filter((item) => item.name !== payload.keyword),
        };

        yield put({ type: tagActions.GET_RECOMMEND_TAG_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_RECOMMEND_TAG_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 상세 미리보기 데이터 요청히기
   */
  yield takeEvery(tagActions.GET_TAG_DETAIL_PREVIEW_DATA_REQUEST, function* ({ payload }) {
    try {
      const { tagInfo, tagMainTab, relatedTagList } = payload;
      const sendData = {
        tagId: tagInfo.tagId,
      };
      const result = yield call(TagApi.getTagDetailPreviewData, setRequestForm(sendData, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        const tagPreviewData = {
          tagInfo,
          tagMainTab,
          tagViewInfo: result.data.tagViewInfo,
          tagDetailPage: {
            relatedTagList,
            itemList: result.data.tagDetailItemList,
          },
        };

        yield put(
          appActions.appToggleModal({
            name: 'tagPreviewModal',
            value: true,
            data: {
              tagPreviewData,
            },
          }),
        );
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_DETAIL_PREVIEW_DATA_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 편집 요청하기
   */
  yield takeEvery(tagActions.EDIT_TAG_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.editTag, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.EDIT_TAG_REQUEST_SUCCESS);

        reDirectPage({ path: TAG_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.EDIT_TAG_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 리스트 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagList, setRequestForm(payload, false));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.GET_TAG_LIST_REQUEST_SUCCESS);

        const data = {
          tagList: _setResponseListForm(result.data.tagList, result.data.totalCnt, payload),
          tagGroupSelectList: result.data.tagGroupSelectList,
        };

        yield put({ type: tagActions.GET_TAG_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 상세 내역 리스트 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_HISTORY_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagHistory, setRequestForm(payload, false));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.GET_TAG_HISTORY_REQUEST_SUCCESS);

        const data = {
          tagHistory: {
            tagInfo: result.data.tagHistory.tagInfo,
            activityHistory: result.data.tagHistory.activityHistory,
            relatedProductList: _setResponseListForm(
              result.data.tagHistory.relatedProductList.list,
              result.data.tagHistory.relatedProductList.totalCnt,
              payload.relatedItemList[TAG_RELATED_ITEM_TYPE.PRODUCT],
            ),
            relatedStoreList: _setResponseListForm(
              result.data.tagHistory.relatedStoreList.list,
              result.data.tagHistory.relatedStoreList.totalCnt,
              payload.relatedItemList[TAG_RELATED_ITEM_TYPE.STORE],
            ),
            relatedEventList: _setResponseListForm(
              result.data.tagHistory.relatedEventList.list,
              result.data.tagHistory.relatedEventList.totalCnt,
              payload.relatedItemList[TAG_RELATED_ITEM_TYPE.EVENT],
            ),
            relatedReviewList: _setResponseListForm(
              result.data.tagHistory.relatedReviewList.list,
              result.data.tagHistory.relatedReviewList.totalCnt,
              payload.relatedItemList[TAG_RELATED_ITEM_TYPE.REVIEW],
            ),
          },
        };

        yield put({ type: tagActions.GET_TAG_HISTORY_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_HISTORY_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 상세에 연결된 아이템 리스트 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_HISTORY_RELATED_ITEM_LIST_REQUEST, function* ({ payload }) {
    try {
      const { tagRelatedItemType } = payload;
      let getApi = null;
      /**
       *  태그에 연관된 아이템 타입 === 상품
       */
      if (tagRelatedItemType === TAG_RELATED_ITEM_TYPE.PRODUCT) getApi = TagApi.getTagHistoryRelatedProductList;
      /**
       *  태그에 연관된 아이템 타입 === 브랜드
       */ else if (tagRelatedItemType === TAG_RELATED_ITEM_TYPE.STORE) getApi = TagApi.getTagHistoryRelatedStoreList;
      /**
       *  태그에 연관된 아이템 타입 === 기획전
       */ else if (tagRelatedItemType === TAG_RELATED_ITEM_TYPE.EVENT) getApi = TagApi.getTagHistoryRelatedEventList;
      /**
       *  태그에 연관된 아이템 타입 === 상품 후기
       */ else if (tagRelatedItemType === TAG_RELATED_ITEM_TYPE.REVIEW) getApi = TagApi.getTagHistoryRelatedReviewList;
      else return;

      const result = yield call(getApi, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      const data = {
        relatedItemList: _setResponseListForm(result.data.relatedItemList, result.data.totalCnt, payload),
        tagRelatedItemType: payload.tagRelatedItemType,
      };

      yield put({ type: tagActions.GET_TAG_HISTORY_RELATED_ITEM_LIST_SUCCESS, payload: data });

      toastMsg.success(tagToastMsg.GET_TAG_HISTORY_RELATED_ITEM_LIST_REQUEST_SUCCESS);
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_HISTORY_RELATED_ITEM_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 그룹명 중복검사 요청하기
   */
  yield takeEvery(tagActions.CHECK_TAG_GROUP_NAME_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.checkTagGroupName, setRequestForm(payload, false));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        yield put({ type: tagActions.CHECK_TAG_GROUP_NAME_SUCCESS, payload: result.data });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.CHECK_TAG_GROUP_NAME_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그에 그룹 연결할 아이템 리스트 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_GROUP_ITEM_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagGroupItemList, setRequestForm(payload, false));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      const data = {
        tagGroupItem: _setResponseListForm(result.data.tagGroupItemList, result.data.totalCnt, payload),
      };

      yield put({ type: tagActions.GET_TAG_GROUP_ITEM_LIST_SUCCESS, payload: data });

      toastMsg.success(tagToastMsg.GET_TAG_GROUP_ITEM_LIST_REQUEST_SUCCESS);
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_GROUP_ITEM_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 그룹 등록 요청하기
   */
  yield takeEvery(tagActions.INSERT_TAG_GROUP_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.insertTagGroup, setRequestForm(payload, false));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.INSERT_TAG_GROUP_REQUEST_SUCCESS);

        reDirectPage({ path: TAG_GROUP_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.INSERT_TAG_GROUP_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 그룹 리스트 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_GROUP_LIST_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagGroupList, setRequestForm(payload, false));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.GET_TAG_GROUP_LIST_REQUEST_SUCCESS);

        const data = {
          tagGroupList: _setResponseListForm(result.data.tagGroupList, result.data.totalCnt, payload),
        };

        yield put({ type: tagActions.GET_TAG_GROUP_LIST_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_GROUP_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 그룹 상세 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_GROUP_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagGroupDetail, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.GET_TAG_GROUP_DETAIL_REQUEST_SUCCESS);

        const data = {
          tagGroupDetail: result.data.tagGroupDetail,
        };

        yield put({ type: tagActions.GET_TAG_GROUP_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_GROUP_DETAIL_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 상세 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_DETAIL_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagDetail, setRequestForm(payload, false));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.GET_TAG_DETAIL_REQUEST_SUCCESS);

        const data = {
          tagGroupSelectList: result.data.tagGroupSelectList,
          tagDetail: result.data.tagDetail,
          tagRelatedProductAndReviewList: result.data.tagRelatedProductAndReviewList,
          tagTabMainContentList: result.data.tagTabMainContentList,
        };

        yield put({ type: tagActions.GET_TAG_DETAIL_SUCCESS, payload: data });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_DETAIL_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 그룹 편집 요청하기
   */
  yield takeEvery(tagActions.EDIT_TAG_GROUP_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.editTagGroup, setRequestForm(payload, false));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.EDIT_TAG_GROUP_REQUEST_SUCCESS);

        reDirectPage({ path: TAG_GROUP_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.EDIT_TAG_GROUP_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 등록 거절 요청하기
   */
  yield takeEvery(tagActions.rejectRegistrationTag, function* ({ payload }) {
    try {
      const result = yield call(TagApi.rejectRegistrationTag, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.REJECT_REGISTRATION_TAG_REQUEST_SUCCESS);

        reDirectPage({ path: TAG_LIST_URL_PATH });
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.REJECT_REGISTRATION_TAG_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 탭 메인 데이터 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_TAB_MAIN_DATA_REQUEST, function* ({ payload }) {
    try {
      const { option } = payload;
      const result = yield call(TagApi.getTagTabMainData, setRequestForm(option, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }
      toastMsg.success(tagToastMsg.GET_TAG_TAB_MAIN_DATA_REQUEST_SUCCESS);

      const data = {
        [TAG_TAB_MAIN_SECTION_TYPE.TAG_TEND_KEYWORD_LIST]: result.data.tagTrendKeywordList,
        [TAG_TAB_MAIN_SECTION_TYPE.TAG_FOLLOW_SELECTED_LIST]: result.data.tagFollowSelectedList,
        activeTagList: _setResponseListForm(result.data.activeTagList, result.data.totalCnt, option),
      };

      yield put({ type: tagActions.GET_TAG_TAB_MAIN_DATA_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_TAB_MAIN_DATA_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 탭 메인에 연결할 컨텐츠 리스트 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_TAB_MAIN_CONTENTS_LIST_REQUEST, function* ({ payload }) {
    try {
      const { tagTabMainSectionType, ...option } = payload;
      const result = yield call(TagApi.getTagTabMainContentsList, setRequestForm(option, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }
      toastMsg.success(tagToastMsg.GET_TAG_TAB_MAIN_CONTENTS_LIST_REQUEST_SUCCESS);

      const data = {
        tagTabMainSectionType,
        activeTagList: _setResponseListForm(result.data.activeTagList, result.data.totalCnt, option),
      };

      yield put({ type: tagActions.GET_TAG_TAB_MAIN_CONTENTS_LIST_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_TAB_MAIN_CONTENTS_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 탭 메인 미리보기 데이터 요청히기
   */
  yield takeEvery(tagActions.GET_TAG_TAB_MAIN_PREVIEW_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagTabMainPreviewData, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        const tagTabMainPreviewData = {
          tagTrendKeywordList: result.data.tagTrendKeywordList,
          tagFollowSelectedList: result.data.tagFollowSelectedList,
        };

        yield put(
          tagActions.toggleModal({
            name: 'tagTabMainPreviewModal',
            value: true,
            data: {
              tagTabMainPreviewData,
            },
          }),
        );
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_TAB_MAIN_PREVIEW_DATA_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 탭 메인 편집 요청하기
   */
  yield takeEvery(tagActions.EDIT_TAG_TAB_MAIN_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.editTagTabMain, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.EDIT_TAG_TAB_MAIN_REQUEST_SUCCESS);
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.EDIT_TAG_TAB_MAIN_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 트렌드 키워드 데이터 요청하기
   */
  yield takeEvery(tagActions.GET_TREND_KEYWORD_DATA_REQUEST, function* ({ payload }) {
    try {
      const { option } = payload;
      const result = yield call(TagApi.getTagTrendKeywordData, setRequestForm(option, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }
      toastMsg.success(tagToastMsg.GET_TREND_KEYWORD_DATA_REQUEST_SUCCESS);

      const data = {
        [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_TOP_RANK_LIST]: result.data.tagTopRankList,
        [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_STYLE_LIST]: result.data.tagStyleList,
        [TAG_TREND_KEYWORD_SECTION_TYPE.RECOMMEND_TAG_COLLECTION_LIST]: result.data.tagCollectionList,
        activeTagList: _setResponseListForm(result.data.activeTagList, result.data.totalCnt, option),
      };

      yield put({ type: tagActions.GET_TREND_KEYWORD_DATA_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TREND_KEYWORD_DATA_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 트렌드 키워드에 연결할 컨텐츠 리스트 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_TREND_KEYWORD_CONTENTS_LIST_REQUEST, function* ({ payload }) {
    try {
      const { tagTrendKeywordSectionType, ...option } = payload;
      const result = yield call(TagApi.getTagTrendKeywordContentsList, setRequestForm(option, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }
      toastMsg.success(tagToastMsg.GET_TAG_TREND_KEYWORD_CONTENTS_LIST_REQUEST_SUCCESS);

      const data = {
        tagTrendKeywordSectionType,
        activeTagList: _setResponseListForm(result.data.activeTagList, result.data.totalCnt, option),
      };

      yield put({ type: tagActions.GET_TAG_TREND_KEYWORD_CONTENTS_LIST_SUCCESS, payload: data });
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_TREND_KEYWORD_CONTENTS_LIST_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 트렌드 키워드 미리보기 데이터 요청히기
   */
  yield takeEvery(tagActions.GET_TAG_TREND_KEYWORD_PREVIEW_DATA_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagTrendKeywordPreviewData, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        const tagTrendKeywordPreviewData = {
          tagTopRankList: result.data.tagTopRankList,
          tagStyleList: result.data.tagStyleList,
          tagCollectionList: result.data.tagCollectionList,
        };

        yield put(
          tagActions.toggleModal({
            name: 'tagTrendKeywordPreviewModal',
            value: true,
            data: {
              tagTrendKeywordPreviewData,
            },
          }),
        );
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_TREND_KEYWORD_PREVIEW_DATA_REQUEST_ERROR, error);
    }
  });

  /**
   *  태그 트렌드 키워드 편집 요청하기
   */
  yield takeEvery(tagActions.EDIT_TAG_TREND_KEYWORD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.editTagTrendKeyword, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
      } else {
        toastMsg.success(tagToastMsg.EDIT_TAG_TREND_KEYWORD_REQUEST_SUCCESS);
      }
    } catch (error) {
      toastMsg.error(tagToastMsg.EDIT_TAG_TREND_KEYWORD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [태그 그룹 등록/편집] 전체 태그 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_GROUP_ALL_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagGroupAllListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(tagToastMsg.GET_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad(TAG_ALL_LIST_EXCEL_FILE_NAME, result.data.tagAllExcelSheet);
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [태그 메인 탭 관리] 전체 태그 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_TAB_MAIN_ALL_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagTabMainAllListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(tagToastMsg.GET_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad(TAG_ALL_LIST_EXCEL_FILE_NAME, result.data.tagAllExcelSheet);
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [태그 트렌드 키워드 관리] 전체 태그 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_TREND_KEYWORD_ALL_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagTrendKeywordAllListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(tagToastMsg.GET_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad(TAG_ALL_LIST_EXCEL_FILE_NAME, result.data.tagAllExcelSheet);
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_ALL_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [태그 그룹 등록/편집] 선택 태그 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_GROUP_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagGroupSelectedListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(tagToastMsg.GET_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad(TAG_SELECTED_LIST_EXCEL_FILE_NAME, result.data.tagSelectedExcelSheet);
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [태그 메인 탭 관리] 선택 태그 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_TAB_MAIN_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagTabMainSelectedListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(tagToastMsg.GET_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad(TAG_SELECTED_LIST_EXCEL_FILE_NAME, result.data.tagSelectedExcelSheet);
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [태그 트렌드 키워드 관리] 선택 태그 리스트 엑셀 다운로드 요청하기
   */
  yield takeEvery(tagActions.GET_TAG_TREND_KEYWORD_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagTrendKeywordSelectedListExcelDownload, setRequestForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(tagToastMsg.GET_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad(TAG_SELECTED_LIST_EXCEL_FILE_NAME, result.data.tagSelectedExcelSheet);
    } catch (error) {
      toastMsg.error(tagToastMsg.GET_TAG_SELECTED_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [태그 그룹 등록/편집] 태그 아이템 EXCEL 업로드하기 성공
   */
  yield takeEvery(tagActions.SET_TAG_GROUP_EXCEL_UPLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.setTagGroupExcelUpload, setMultipartForm(payload, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(tagToastMsg.SET_TAG_EXCEL_UPLOAD_REQUEST_SUCCESS);

      yield put({ type: tagActions.SET_TAG_GROUP_EXCEL_UPLOAD_SUCCESS, payload: result.data });

      yield asyncSimpleModal({
        type: 'info',
        title: '태그 업로드',
        message: `${result.data.itemList.length}개의 태그 아이템이 성공적으로 등록되었습니다.`,
      });
    } catch (error) {
      toastMsg.error(tagToastMsg.SET_TAG_EXCEL_UPLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [태그 메인 탭 관리] 태그 엑셀 업로드
   */
  yield takeEvery(tagActions.SET_TAG_TAB_MAIN_EXCEL_UPLOAD_REQUEST, function* ({ payload }) {
    try {
      const { attachment, tagTabMainSectionType } = payload;
      const result = yield call(TagApi.setTagTabMainExcelUpload, setMultipartForm({ attachment }, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(tagToastMsg.SET_TAG_EXCEL_UPLOAD_REQUEST_SUCCESS);

      yield put({
        type: tagActions.SET_TAG_TAB_MAIN_EXCEL_UPLOAD_SUCCESS,
        payload: {
          ...result.data,
          tagTabMainSectionType,
        },
      });

      yield asyncSimpleModal({
        type: 'info',
        title: '태그 업로드',
        message: `${result.data.itemList.length}개의 태그 아이템이 성공적으로 등록되었습니다.`,
      });
    } catch (error) {
      toastMsg.error(tagToastMsg.SET_TAG_EXCEL_UPLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [태그 트렌드 키워드 관리] 태그 엑셀 업로드
   */
  yield takeEvery(tagActions.SET_TAG_TREND_KEYWORD_EXCEL_UPLOAD_REQUEST, function* ({ payload }) {
    try {
      const { attachment, tagTrendKeywordSectionType } = payload;
      const result = yield call(TagApi.setTagTrendKeywordExcelUpload, setMultipartForm({ attachment }, true));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(tagToastMsg.SET_TAG_EXCEL_UPLOAD_REQUEST_SUCCESS);

      yield put({
        type: tagActions.SET_TAG_TREND_KEYWORD_EXCEL_UPLOAD_SUCCESS,
        payload: {
          ...result.data,
          tagTrendKeywordSectionType,
        },
      });

      yield asyncSimpleModal({
        type: 'info',
        title: '태그 업로드',
        message: `${result.data.itemList.length}개의 태그 아이템이 성공적으로 등록되었습니다.`,
      });
    } catch (error) {
      toastMsg.error(tagToastMsg.SET_TAG_EXCEL_UPLOAD_REQUEST_ERROR, error);
    }
  });

  /**
   *  [태그 리스트] 엑셀 다운로드
   */
  yield takeEvery(tagActions.GET_TAG_LIST_EXCEL_DOWNLOAD_REQUEST, function* ({ payload }) {
    try {
      const result = yield call(TagApi.getTagListExcelDownload, setRequestForm(payload));
      if (result.msg) {
        toastMsg.error(result.msg);
        return;
      }

      toastMsg.success(tagToastMsg.GET_TAG_LIST_EXCEL_DOWNLOAD_REQUEST_SUCCESS);

      excelDownLoad(TAG_LIST_EXCEL_FILE_NAME, result.data.tagListExcelSheet);
    } catch (e) {
      toastMsg.error(tagToastMsg.GET_TAG_LIST_EXCEL_DOWNLOAD_REQUEST_ERROR, e);
    }
  });
}

export default function* widgetSaga() {
  yield fork(fetchList);
}
